<template>
        <section class="user_section">
<!--            <UserLnb :navTitle="navTitle" :bgStyle="'type2'" />-->
            <div class="title jc">
                <h2>오시는 길</h2>
            </div>
                                  
            <article class="view intro">
                <div>
                    <div class="map_wrap">
                        <div id="map" style="width:100%;height:420px;"></div>
                        <div class="map_info">
                            <div class="map_addr">
                                <span class="map_addr_icon">📍</span>
                                <span>서울시 강서구 화곡로63길 93 신송타워 201호</span>
                            </div>
                            <button class="btn btn_md btn_brown map_link_btn" @click="openWindow">
                                카카오맵에서 보기
                            </button>
                        </div>
                    </div>
                    <ul class="intro_list">
                        <li>
                            <h6>오시는 길</h6>
                            <div class="con_box">
                                <p>[버스로 오시는 방법]</p>
                                <p>
                                    KBS스포츠월드 정거장에서 내리신 후  <br> 
                                    등촌3동 주민센터쪽으로 도보로 5분정도 거리에 위치하고 있습니다. <br>
                                </p>
                            </div>
                        </li>
                        <li>
                            <h6></h6>
                            <div class="con_box">
                                <div class="box">
                                    <span>평일</span>
                                    <div class="info_box">
                                        <p>09:00 ~ 18:00</p>
                                        <p>점심시간 오후1시 ~ 오후2시</p>
                                    </div>
                                </div>
                                <div class="box">
                                    <span>토요일</span>
                                    <div class="info_box">
                                        <p>09:00 ~ 16:00</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <h6>전화번호</h6>
                            <div class="con_box">
                                <a href="tel:02-6952-1514">02-6952-1514</a>
                            </div>
                        </li>                        
                        <li>
                            <h6>사업자정보</h6>
                            <div class="con_box">
                                <div class="box">
                                    <span>상호명</span>
                                    <div class="info_box">
                                        코끼리원외탕전
                                    </div>
                                </div>
                                <div class="box">
                                    <span>대표자</span>
                                    <div class="info_box">
                                        안가청
                                    </div>
                                </div>
                                <div class="box">
                                    <span>사업자번호</span>
                                    <div class="info_box">
                                       169-94-01307
                                    </div>
                                </div>
                                <div class="box">
                                    <span>이메일</span>
                                    <div class="info_box">
                                      seoulkogiri@gmail.com
                                    </div>
                                </div>
                            </div>
                        </li>                                              
                    </ul>              
                </div>
            </article>
                       
        </section>
</template>
<script>

    export default {
        components: {
        },
        watch: {

        },
        mounted() {
            /* global kakao */
            const load = () => kakao.maps.load(() => this.initMap())
            if (window.kakao && window.kakao.maps) {
                load()
            } else {
                const script = document.createElement("script")
                script.onload = load
                script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=f213c964ca1b2d3c2f0de68a1306383c&autoload=false&libraries=services"
                document.head.appendChild(script)
            }
        },
        methods: {
            initMap () {
                const container = document.getElementById("map")
                const geocoder = new kakao.maps.services.Geocoder()
                geocoder.addressSearch('서울특별시 강서구 화곡로63길 93', (result, status) => {
                    const coords = status === kakao.maps.services.Status.OK
                        ? new kakao.maps.LatLng(result[0].y, result[0].x)
                        : new kakao.maps.LatLng(37.552060261462984, 126.91263978816121)
                    this.map = new kakao.maps.Map(container, { center: coords, level: 3 })
                    new kakao.maps.Marker({ map: this.map, position: coords })
                })
            },   
            openWindow () {
                window.open('https://map.kakao.com/?q=%EC%9C%BC%EB%9E%8F%EC%B0%A8%EC%B0%A8%ED%95%9C%EC%9D%98%EC%9B%90')
            }
        },
        data () {
            return {
                currentMenu: 0,
                navTitle: ['탕전실 소개', '오시는 길'],
                map: null
            }
        }
    }
</script>

<style scoped>
  .map_wrap {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 30px;
  }

  #map {
    width: 100%;
    height: 420px;
  }

  .map_info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: #f9f6f0;
    border-top: 1px solid #e0d8cc;
  }

  .map_addr {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 1.5rem;
    color: #333;
    font-weight: 500;
  }

  .map_addr_icon {
    font-size: 1.6rem;
  }

  .map_link_btn {
    flex-shrink: 0;
    margin-left: 16px;
  }
</style>